// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1z0ZQ","signatureBlock":"Footer_signatureBlock__17c3L","signature":"Footer_signature__1P-Gk"};